import { shadeColor } from '@app/utils/utils';
import { graphic } from 'echarts';
import { BASE_COLORS } from '../constants';
import { ITheme } from '../types';

const chartColors = {
  chartTooltipLabel: '#64748B',
  chartColor1: '#2563EB',
  chartColor1Tint: '#60A5FA',
  chartColor2: '#0F766E',
  chartColor2Tint: '#2DD4BF',
  chartColor3: '#D97706',
  chartColor3Tint: '#FBBF24',
  chartColor4: '#16A34A',
  chartColor4Tint: '#4ADE80',
  chartColor5: '#DC2626',
  chartColor5Tint: '#F87171',
  chartPrimaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(37, 99, 235, 0.24)'
    },
    {
      offset: 1,
      color: 'rgba(37, 99, 235, 0)'
    }
  ]),
  chartSecondaryGradient: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(255, 82, 82, 0.5)'
    },
    {
      offset: 1,
      color: 'rgba(255, 255, 255, 0)'
    }
  ]),
  chartSecondaryGradientSpecular: new graphic.LinearGradient(0, 0, 0, 1, [
    {
      offset: 0,
      color: 'rgba(255, 255, 255, 0)'
    },
    {
      offset: 1,
      color: 'rgba(255, 82, 82, 0.5)'
    }
  ])
};

export const lightColorsTheme: ITheme = {
  logoText: '#0F172A',
  logoTextSpan: '#2563EB',
  primary: '#2563EB',
  primary1: '#EFF6FF',
  primaryGradient: 'linear-gradient(135deg, #2563EB 0%, #0EA5E9 100%)',
  secondaryGradient: 'linear-gradient(135deg, #F8FAFC 0%, #DBEAFE 100%)',
  light: '#E2E8F0',
  secondary: '#0EA5E9',
  error: '#DC2626',
  warning: '#D97706',
  success: '#16A34A',
  background: BASE_COLORS.white,
  secondaryBackground: '#F8FAFC',
  secondaryBackgroundSelected: shadeColor('#F8FAFC', -5),
  additionalBackground: '#ffffff',
  collapseBackground: '#2563EB',
  timelineBackground: '#F8FAFC',
  siderBackground: '#ffffff',
  spinnerBase: '#2563EB',
  scroll: '#CBD5E1',
  border: '#E2E8F0',
  borderNft: '#CBD5E1',
  textMain: '#0F172A',
  textLight: '#64748B',
  textSuperLight: '#94A3B8',
  textSecondary: '#334155',
  textDark: '#0F172A',
  textNftLight: '#64748B',
  textSiderPrimary: '#2563EB',
  textSiderSecondary: '#475569',
  subText: '#64748B',
  shadow: 'rgba(15, 23, 42, 0.08)',
  boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.06)',
  boxShadowHover: '0 10px 20px rgba(15, 23, 42, 0.12)',
  boxShadowNft:
    '0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  boxShadowNftSecondary:
    '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  dashboardMapBackground: '#EFF6FF',
  dashboardMapCircleColor: '#93C5FD',
  dashboardMapControlDisabledBackground: '#E2E8F0',
  notificationSuccess: '#ECFDF5',
  notificationPrimary: '#EFF6FF',
  notificationWarning: '#FFFBEB',
  notificationError: '#FEF2F2',
  heading: '#0F172A',
  borderBase: '#CBD5E1',
  disable: 'rgba(0, 0, 0, 0.25)',
  disabledBg: '#E2E8F0',
  layoutBodyBg: '#F8FAFC',
  layoutHeaderBg: 'transparent',
  layoutSiderBg: '#FFFFFF',
  inputPlaceholder: '#94A3B8',
  itemHoverBg: '#EFF6FF',
  backgroundColorBase: '#F1F5F9',
  avatarBg: '#E2E8F0',
  alertTextColor: BASE_COLORS.white,
  breadcrumb: '#64748B',
  icon: '#64748B',
  iconHover: '#0F172A',
  ...chartColors
};
